import { useMemo } from "react";
import { IDriverMember } from "../components/card/card";
import { TaskCategory, type ShiftTask } from "@/logic/api";

export interface DriverShiftSummary {
  activeDriverCount: number; // Total drivers on shift and on break
  drivingCount: number;
  notDrivingCount: number;
  onShiftCount: number;
  onBreakCount: number;
  totalDriverCount: number;
}

export const useDriverSummary = (
  drivers: IDriverMember[],
  tasks: ShiftTask[]
): DriverShiftSummary => {
  return useMemo(() => {
    const drivingTaskKeys = new Set(
      tasks.filter((t) => t.category === TaskCategory.Driving).map((t) => t.key)
    );

    const counts = drivers.reduce(
      (acc, driver) => {
        const isActive = driver.status === "on-shift" || driver.status === "on-break";

        if (driver.status === "on-shift") acc.onShiftCount++;
        if (driver.status === "on-break") acc.onBreakCount++;

        if (isActive) {
          acc.activeDriverCount++;

          if (driver.status === "on-shift" && drivingTaskKeys.has(driver.assignment)) {
            acc.drivingCount++;
          } else {
            acc.notDrivingCount++;
          }
        }

        return acc;
      },
      {
        activeDriverCount: 0,
        drivingCount: 0,
        notDrivingCount: 0,
        onShiftCount: 0,
        onBreakCount: 0,
      }
    );

    return {
      ...counts,
      totalDriverCount: drivers.length,
    };
  }, [drivers, tasks]);
};
